/**
 * @description Renders the Personnel Sync page, which includes the form and sync results
 */

import React from 'react';
import Typography from '@mui/material/Typography';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';
import SyncResults from '@seccon/shared/personnelSyncResults/components/SyncResults';
import { SyncResultsProvider, SyncResultsContext } from '@seccon/shared/personnelSyncResults/contexts/SyncResults';
import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';
import filePondGlobalStyles from '@seccon/core/filepond/styles';
import '@seccon/core/filepond/plugins';

import SyncForm from './components/SyncForm';

const styles = {
  bodyContainer: {
    alignItems: 'center'
  },
  pageHeader: {
    width: '100%'
  },
  header: {
    width: '100%'
  }
};

/**
 * Renders the sync results section. Its kept as its own component outside of the PersonnelMapping component
 *  so it can read from the sync results context.
 */
const Results = () => {
  const results = React.useContext(SyncResultsContext);

  // If no results are ready to be display, render nothing
  if (results === null) {
    return null;
  }

  return (
    <>
      <Typography variant='h5' sx={styles.header} gutterBottom>
        Sync Results
      </Typography>
      <SyncResults />
    </>
  );
};

const PersonnelSync = () => (
  <BodyContainer sx={styles.bodyContainer}>
    {filePondGlobalStyles}
    <SyncResultsProvider>
      <Typography variant='h4' sx={styles.pageHeader} gutterBottom>
        Personnel Sync Tool
      </Typography>
      <Typography variant='h5' sx={styles.header} gutterBottom>
        Sync Form
      </Typography>
      <ErrorBoundary>
        <SyncForm />
      </ErrorBoundary>
      <ErrorBoundary>
        <Results />
      </ErrorBoundary>
    </SyncResultsProvider>
  </BodyContainer>
);

export default PersonnelSync;
